module.exports = __webpack_public_path__ + "assets/img/budapark3-1920.ef86659a.webp";